import React from 'react'
interface StartRecordingIconProps {
  size?: 'sm' | 'md' | 'lg'
  v2?: boolean
  circle?: boolean
}
export function StartRecordingIcon({ size, v2, circle }: StartRecordingIconProps) {
  if (size === 'sm') {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" className="fill-danger-icon" />
      </svg>
    )
  } else if (size === 'md') {
    if (v2 && circle) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="9.5" fill="white" stroke="white" />
          <circle cx="10" cy="10" r="9.5" fill="white" stroke="#C6CED2" />
          <rect x="2" y="2" width="16" height="16" rx="8" fill="#E22F4F" />
        </svg>
      )
    } else if (v2) {
      return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9.5" fill="white" stroke="white" />
          <circle cx="10" cy="10" r="9.5" fill="white" stroke="#C6CED2" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 6.44721C6.49743 5.33253 7.69614 4.63819 8.65704 5.19776L14.7782 8.76236C15.7386 9.32163 15.7411 10.7141 14.7828 11.2692L8.67801 14.8054C7.71968 15.3605 6.51896 14.662 6.51639 13.5479L6.5 6.44721Z"
            fill="#69717A"
          />
        </svg>
      )
    }
    return (
      <div className="w-5 h-5 relative">
        <div className="w-4 h-4 left-0.5 top-0.5 absolute bg-danger-icon rounded-full" />
      </div>
    )
  } else {
    return (
      <div className="w-10 h-10 relative">
        <div className="w-9 h-9 left-0.5 top-0.5 absolute bg-danger-icon rounded-full" />
      </div>
    )
  }
}
